export default {
    data() {
        return {
            isShowSlideBar: false,
        }
    },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    handleScroll() {
      const navHeight =
        document.getElementsByClassName("pc_header-content")[0].offsetHeight;
      const mainHeight =
        document.getElementsByClassName("video-wrap")[0]?.offsetHeight;
      if (document.scrollingElement.scrollTop + navHeight < mainHeight) {
        this.isShowSlideBar = false;
      } else {
        this.isShowSlideBar = true;
      }
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll, true);
  },
};
